module.exports = __webpack_public_path__ + "img/device_home.2033be1f.png";